export const uk = {
    'request-error': 'Произошла непредвиденная ошибка.'
};
